import React from "react";
import CustomModal from "../../../Core/Components/Modal/CustomModal";
import { CloseWithCircleIcon } from "../../../Common/Svgs/CloseIcon";
import Button from "../../../Core/Components/CustomButton";

const RestartModal = ({ visible, onCancel, onRestart }) => {
  return (
    <CustomModal visible={visible} onCancel={onCancel} width="536px">
      <div
        className="p-4"
        style={{
          boxShadow:
            "12px 12px 16px -4px rgba(16, 24, 40, 0.08), -4px -4px 6px -2px rgba(16, 24, 40, 0.03)",
        }}
      >
        <div className="flex items-center justify-between">
          <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#F9ECEA]">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="32"
              height="32"
              fill="none"
              viewBox="0 0 32 32"
            >
              <path
                fill="#F18725"
                stroke="#F18725"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
                d="M16 29.333c7.334 0 13.334-6 13.334-13.333S23.334 2.667 16 2.667 2.667 8.667 2.667 16s6 13.333 13.333 13.333"
              />
              <path
                stroke="#FAFAFA"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
                d="M16 10.667v6.666"
              />
              <path
                stroke="#FAFAFA"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M15.992 21.333h.012"
              />
            </svg>
          </div>

          <button type="button" className="mr-2" onClick={onCancel}>
            <CloseWithCircleIcon />
          </button>
        </div>

        <div className="mt-5 px-2 pb-2">
          <h1 className="font-poppins text-xl font-semibold">
            Restart the process?
          </h1>

          <p className="mt-1 font-aileron text-sm font-normal text-grey-200">
            Are you sure you want to restart measuring the land?
          </p>

          <div className="mt-6 flex items-center gap-x-3">
            <Button
              colors="grey"
              size="primary"
              width="full"
              onClick={onCancel}
            >
              Cancel
            </Button>

            <Button
              colors="primary"
              size="primary"
              width="full"
              onClick={onRestart}
            >
              Restart
            </Button>
          </div>
        </div>
      </div>
    </CustomModal>
  );
};

export default RestartModal;
